import { generateResourceSelectors } from '../generators/resource.selectors';

import * as types from './event.types';

export const eventSelectors = {
  ...generateResourceSelectors<types.IEvent>((state) => state.resource.event),
};
